// 流程状态
import React from 'react'
import { connect } from 'react-redux' 
import { hasChangedValues } from '../../public/utility/formValues' 
import ProcessInputParaSetDiv from './ProcessInputParaSetDiv'
class ProcessFormItemDiv extends React.Component {
    state = {
        changedValues基本信息: {},
        id: this.props.id,
        ProcessID: this.props.ProcessID,
        FatherID: this.props.FatherID,
    }

    componentDidMount = () => {
        const { id, ProcessID, FatherID } = this.props
        this.doGetProcessFormItem(id, ProcessID, FatherID)
    }
    componentWillUnmount = () => {
        this.unmount = true
    }
    doGetProcessFormItem = (id, ProcessID, FatherID) => {
        Tyan.doPostEvent({
            event: 'GetProcessFormItem',
            data: { id, ProcessID, FatherID },
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
                }
            }
        })
    }

    handlerSave = () => {
        const { ProcessID, FatherID, onRefresh, onClose } = this.props
        const { id, changedValues基本信息, initValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        Tyan.doPostEvent({
            event: 'SaveProcessFormItem',
            data: { id, ProcessID, FatherID, changedValues基本信息: values },
            onEnd: ({ id, errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('保存成功')
                    onRefresh && onRefresh()
                    onClose && onClose()
                    //this.doGetProcessFormItem(id)
                }
            }
        })
    }

    handlerDelete = () => {
        const { id } = this.state
        const { onRefresh, onClose } = this.props

        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DeleteProcessFormItem',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onRefresh && onRefresh()
                        onClose && onClose()
                    }
                }
            }))
    }

    handlerClose = () => {
        const { onRefresh, onClose } = this.props
        if (!this.bChanged()) {
            onRefresh && onRefresh()
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', () => {
            onRefresh && onRefresh()
            onClose && onClose()
        })
    }

    bSave = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        return Object.keys(changedValues基本信息).length > 0 && values.表单项名称
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    handlerAddChildFormItem = () => {
        const { ProcessID, FatherID } = this.props
        const { id, changedValues基本信息, initValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        Tyan.doPostEvent({
            event: 'SaveProcessFormItem',
            data: { id, FatherID, ProcessID, changedValues基本信息: values },
            onEnd: ({ id, errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {} })
                    Tyan.pubForm.showDialog('子表单项设置', props => <ProcessFormItemDiv {...props} id={0} ProcessID={ProcessID} FatherID={id} onRefresh={() => this.doGetProcessFormItem(id, ProcessID, FatherID)} />)
                }
            }
        })
    }

    handlerSetInputPara = () => {
        const { ProcessID, FatherID } = this.props
        const { id, changedValues基本信息, initValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        Tyan.doPostEvent({
            event: 'SaveProcessFormItem',
            data: { id, FatherID, ProcessID, changedValues基本信息: values },
            onEnd: ({ id, errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('保存成功')
                    this.setState({ id })
                    Tyan.pubForm.showDialog('输入参数设置', props => <ProcessInputParaSetDiv {...props} id={id} onRefresh={() => this.doGetProcessFormItem(id, ProcessID, FatherID)} />)
                }
            }
        })
    }

    fieldset基本信息 = () => {
        const { FatherID } = this.props
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }

        var listField = []
        if (FatherID && FatherID > 0)
            listField.push({ _text: '父表单项名称', disabled: true, minWidth: '45%' })
        listField.push(
            { _text: '表单项名称', required: true, minWidth: FatherID && FatherID > 0 ? '45%' : '95%' },
            { _text: '显示名称', minWidth: '45%' },
            { _select: '数据类型', minWidth: '45%' },
            { _radio: '是否必填', minWidth: '45%' },
            { _radio: '占用列数', name: '列数', minWidth: '45%' },
            { _text: '输入参数', minWidth: 'calc(45% - 100px)', cdt: () => [8, 9, 10].indexOf(values.数据类型) == -1 },
            {
                _buttons: [
                    { _button: '设置...', handler: this.handlerSetInputPara, },
                ], width: '80px', margin: '0px 20px 0px 0px', cdt: () => [8, 9, 10].indexOf(values.数据类型) == -1
            },
            { _select: '子流程', minWidth: '45%', cdt: () => values.数据类型 == 10 },
            { _text: '呈现参数', minWidth: '45%', cdt: () => [9, 10].indexOf(values.数据类型) !== -1 },
            { _text: '显示条件', minWidth: '95%' },
            //{ _text: '编辑条件', minWidth: '45%' },
            { _radio: '是否刷新', minWidth: '45%' },
            { _radio: '呈现方式', minWidth: '45%', cdt: () => values.数据类型 == 9 },
            { _int: '排序', minWidth: '45%' }
        )
        return listField
    }

    fieldset子表单项 = () => {
        const { id } = this.state
        const { ProcessID } = this.props
        return [{
            _grid: '', name: '子表单项', rowNumbers: true, minRows: 3, /*minRows: 3, maxRows: 11, */ height: '100%',
            columns: [
                { _text: '表单项名称', flex: 2 },
                { _text: '显示名称', flex: 2 },
                { _text: '数据类型', flex: 2 },
            ],
            buttons: [
                { _button: '添加...', /* icon: 'plus', */  handler: this.handlerAddChildFormItem, },
            ],
            onDoubleTap: data => {
                Tyan.pubForm.showDialog('子表单项设置', props => <ProcessFormItemDiv {...props} id={data.id} ProcessID={ProcessID} FatherID={id} onRefresh={() => this.doGetProcessFormItem(id)} />)
            }
        }]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { errorMessage, id, initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        return <Body data={this} minWidth="800" maxWidth="1100"
            controls={
                [
                    { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.bSave(), },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
                    values && (values.数据类型 == 8 || values.数据类型 == 9) && { title: '子表单项', docked: 'bottom', name: '基本信息', _fieldset: this.fieldset子表单项(), fullblock: true },
                ]}
        />
    }
}

export default connect()(ProcessFormItemDiv)